// data/about-transparency.ts

export interface Badge {
  id: string;
  label: string;
  sublabel: string;
}

export interface AboutTransparencyContent {
  background: {
    src: string;
    alt: string;
  };
  card: {
    heading: string;
    badges: Badge[];
    testimonial: {
      quote: string;
      authorName: string;
      authorRole: string;
    };
    stat: {
      value: number;
      suffix: string;
      label: string;
    };
  };
}

export const ABOUT_TRANSPARENCY_CONTENT: AboutTransparencyContent = {
  background: {
    src: "/hero/marblev2.webp",
    alt: "Skilled artisan crafting premium handcrafted products in a manufacturing workshop",
  },

  card: {
    heading: "Built on trust, quality & transparency",

    badges: [
      {
        id: "b1",
        label: "20+ Categories",
        sublabel: "Custom Products",
      },
      {
        id: "b2",
        label: "Global Export",
        sublabel: "International Standards",
      },
      {
        id: "b3",
        label: "Made to Order",
        sublabel: "Fully Customized",
      },
    ],

    testimonial: {
      quote:
        "The Quality Collection Private Limited transformed our concept into a premium product with exceptional craftsmanship. Their communication, flexibility, and attention to every detail made the entire sourcing process effortless.",
      authorName: "International Buyer",
      authorRole: "Private Label Brand",
    },

    stat: {
      value: 20,
      suffix: "+",
      label: "Product categories mastered",
    },
  },
};

/* Design tokens for the section */
export const TRANSPARENCY_COLORS = {
  cardBg: "#d4e816", // Signature lime/yellow
  cardText: "#0a0a0a",
  cardMuted: "#1c1c1c",
} as const;
